import React from 'react';
import { Box, keyframes } from '@edreamsodigeo/prisma-design-system';

const blurAnimation = keyframes`
    0% {
        filter: blur(0px);
    }
    20% {
        filter: blur(0.1px);
    }
    30% {
        filter: blur(0.3px);
    }
    40% {
        filter: blur(0.4px);
    }
    50% {
        filter: blur(0.5px);
    }
    60% {
        filter: blur(0.4px);
    }
    70% {
        filter: blur(0.3px);
    }
    80% {
        filter: blur(0.1px);
    }
    100% {
        filter: blur(0px);
    }
`;

export const BlurText = ({ children, delay, duration = 1300 }) => {
  return (
    <Box
      sx={{
        animationName: `${blurAnimation}`,
        animationDuration: `${duration}ms`,
        animationTimingFunction: 'cubic-bezier(0.001, 0.01, 0.001, 1)',
        animationDelay: `${delay || 0}ms`,
        animationIterationCount: 'infinite',
      }}
    >
      {children}
    </Box>
  );
};
